import { render, staticRenderFns } from "./CierreComercio.vue?vue&type=template&id=0c5f1462&scoped=true&"
import script from "./CierreComercio.vue?vue&type=script&lang=js&"
export * from "./CierreComercio.vue?vue&type=script&lang=js&"
import style0 from "./CierreComercio.vue?vue&type=style&index=0&id=0c5f1462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f1462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
